export default "/images/4520064f47b66a8ecca3365183516b6d.avif";